import React, { Component } from 'react';

import { firebaseConnect, helpers } from 'react-redux-firebase';

import MetricsPanelList from 'components/Metrics/MetricsPanelList';

export default class MetricsList extends Component {

    constructor (props) {
        super(props);
    }

	render () {
		return (
			<div className="metrics">
				<MetricsPanelList
					profile = {this.props.profile}
					classrooms = {this.props.classrooms}
					products={this.props.products}
					orders={this.props.orders}
					school={this.props.schools}
					customers={this.props.customers}
					selectedClassroom={this.props.selectedClassroom}
				/>
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./js/components/MetricsList.js